<template>
  <div class="container">
    <ClientBox>
      <div class="cards">
        <ul>
          <li v-for="(item , index) in cards" :key="index">
            <span>{{item.name}}
              <!-- <img src="@/assets/images/logo.png" alt="LogoEn" /> -->
            </span>
            <h3>{{numeral(item.value).format('0,0.00')}}</h3>
            <p>
              {{item.account}}
              <!-- <img src="@/assets/images/Client/card-logo.png" alt="LogoEn" /> -->
            </p>
          </li>
        </ul>
      </div>

      <div class="midden">
        <div id="pie" class="pie"></div>
        <div id="rate" class="rate">
          <img src="@/assets/images/Client/lines.png" alt="lines"/>
          <ul>
            <li v-for="(item , index) in days" :key="index">{{item}}</li>
          </ul>
        </div>
      </div>

      <div class="bottom">
        <div id='bar' class="bar"></div>
      </div>
    </ClientBox>

    <div class="exchange">
      <div class="step1">
        <div class="input">
        <span>
          <img src="@/assets/images/Region/region-31.png" alt="USD"/>
          USD
        </span>
          <span>{{numeral(usdNum).format('0,0.00')}}</span>
        </div>

        <div class="line">
          <span></span>
          <p>1 USD = {{rate}} CNY</p>
        </div>

        <div class="input">
        <span>
          <img src="@/assets/images/Region/region-3.png" alt="CNY"/>
          CNY
        </span>
          <span>{{numeral(cnyNum).format('0,0.00')}}</span>
        </div>
        <div class="btn" ref="btn">Transfer</div>
      </div>

      <div :class="`step2 ${showStep2 && 'showStep2'}`">
        <div class="circle">
          <div class="svgAni">
            <svg width="220" height="220">
              <defs>
                <linearGradient id="grad" x1="100%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0" stop-color="#4D3AFF" />
                  <stop offset="1" stop-color="#E755FF" />
                </linearGradient>
              </defs>
              <circle fill="none" stroke="#FFF" stroke-width="10" cx="110" cy="110" r="95" stroke-linecap="round" />
              <circle class="circleAni" ref="svg_circle" fill="none" stroke="url(#grad)" stroke-width="11" cx="-110" cy="110" r="95"  stroke-linecap="round" />
              <polyline class="tickAni" ref="svg_tick" fill="none" stroke="#FFF" stroke-width="10" points="70.5,96.3 100.2,119.4 146.8,69.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p>{{moveEnd ? 'Done' : ''}}</p>
          </div>
          <p class="tips">{{moveEnd ? '' : 'Processing'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import numeral from 'numeral';
  import tween from "@tweenjs/tween.js";
  import ClientBox from '../ClientBox'
  import base from '../base'

  export default {
    extends: base,
    name: "ClientAnimation",
    components: {
      ClientBox,
    },
    data() {
      return {
        numeral,
        usdNum: 0,
        cnyNum: 0,
        rate: 6.8103,
        cards : [
          {
            name: 'CNY',
            value: 7263.9,
            account: '0314',
          },
          {
            name: 'USD',
            value: 6763.7,
            account: '0405',
          },
          {
            name: 'HKD',
            value: 8763.4,
            account: '0748',
          },
        ],
        days: ['12-01','12-03','12-06','12-09','12-12','12-15','12-18'],
        //饼图相关
        pieChart: null,
        pieOption: {
          animation: false,
          color:['#515DE1', '#20BD74' , '#00CCFF'],
          series: [{
            type: 'pie',
            radius: ['50%', '70%'],
            label: {
              show: false,
              position: 'center',
              formatter: '{b}\n\n{c}',
              color: '#A2A8AC'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
              }
            },
            labelLine: { show: false },
            data: [],
          }]
        },
        //柱状图
        barColor: ['#20BD74' , '#515DE1', '#00CCFF'],
        barChart: null,
        barOption : {
          animation: false,
          grid: { left: 5, top: 30 , right: 5, bottom: 25 },
          xAxis: {
            data: [1,2,3,4,5,6,7,8,9],
          },
          yAxis: {
            show: false,
          },
          series: [{
            data: [160, 200, 120, 160, 140, 190, 140, 180, 110],
            barWidth: 12,//柱子的宽度
            type: 'bar',
            itemStyle: {
              barBorderRadius: [16,16,0,0],
              color: (params) => {
                return this.barColor[(params.dataIndex+1)%3];
              },
            },
          }]
        },
        //进度条相关
        showStep2: false,
        moveArc: false,
        moveArcMask: false,
        moveEnd: false,
      }
    },
    mounted() {
      function animate(time) {
        requestAnimationFrame(animate)
        tween.update(time)
      }
      requestAnimationFrame(animate)

      this.drawPie();
      this.drawBar();

      this.setTimeOut(() => {
        this.changeNum();
      },3000);

      this.cycle = setInterval(() => {this.changeNum();}, 20000);
    },
    destroyed() {
      if(this.cycle){
        clearInterval(this.cycle);
        this.cycle = null;
      }
      if(this.inputNum){
        clearInterval(this.inputNum);
        this.inputNum = null;
      }
    },
    methods: {
      drawPie() {
        this.pieOption.series[0].data = this.cards;
        // 基于准备好的dom，初始化echarts实例
        this.pieChart = this.$echarts.init(document.getElementById("pie"));
        // 绘制图表
        this.pieChart.setOption(this.pieOption);

        this.pieChart.dispatchAction({
          type: 'highlight',
          name: this.cards[0].name,
        })
      },

      drawBar() {
        // 基于准备好的dom，初始化echarts实例
        this.barChart = this.$echarts.init(document.getElementById("bar"));
        // 绘制图表
        this.barChart.setOption(this.barOption);
      },
      changeNum() {
        if(this.inputNum){
          clearInterval(this.inputNum);
          this.inputNum = null;
        }
        //重置数据
        this.cards[0].value = 7263.9;
        this.cards[1].value = 6763.7;
        this.pieOption.series[0].data = this.cards;
        this.pieChart.setOption(this.pieOption);

        this.inputNum =  setInterval(() => {
          this.usdNum = this.usdNum === 0 ? 1 : this.usdNum * 10;
          this.cnyNum = this.usdNum * this.rate;
          if(this.usdNum >= 1000) {
            clearInterval(this.inputNum);
            this.inputNum = null;

            this.setTimeOut(() => {
              this.exchangeAnmation();
            },500);
          }
        },150)
      },
      //兑换框动画
      exchangeAnmation() {
        if(!this.$refs.btn) return;
        this.moveArc = false;
        this.moveArcMask = false;
        this.moveEnd = false;

        this.$refs.btn.style.transform = "scale(" + 0.9 + ")";
        this.setTimeOut(() => {
          this.$refs.btn.style.transform = "scale(" + 1 + ")";

          this.setTimeOut(() => {
            this.showStep2 = true;

            //进度条 添加动画
            this.setTimeOut(() => {
              this.$refs.svg_circle.setAttribute("class", "circleAni circlePlay");
              this.$refs.svg_tick.setAttribute("class", "tickAni tickPlay");
            },1000);

            //动画完成
            this.setTimeOut(() => {
              this.moveEnd = true;
            },1900);

            //播放客户端动画
            this.setTimeOut(() => {
              this.usdNum = 0;
              this.cnyNum = 0;
              this.showStep2 = false;
            },3500);

            this.setTimeOut(() => {
              //动画复位
              this.$refs.svg_circle.setAttribute("class", "circleAni circleRevert");
              this.$refs.svg_tick.setAttribute("class", "tickAni tickRevert");
              this.clientAnmation();
            },4500);

          },500)

        },200)
      },
      //客户端动效
      clientAnmation() {
        if(!this.pieChart) return;
        new tween.Tween({ number: this.cards[1].value }).to({ number: this.cards[1].value - 1000 }, 800).onUpdate(t => {
          this.cards[1].value = t.number.toFixed(1);
        }).start();
        this.cards[0].value = parseFloat(this.cards[0].value);
        new tween.Tween({ number: this.cards[0].value }).to({ number: this.cards[0].value + 6810.3 }, 800).onUpdate(t => {
          this.cards[0].value = t.number.toFixed(1);
          this.pieOption.series[0].data = this.cards;
          this.pieChart.setOption(this.pieOption);
        }).start();
      }
    }
  }
</script>

<style lang="less" scoped>

  .container {
    position: relative;
    user-select: none;
  }

  .cards {
    flex-grow: 1;
    background: #3A3D40;
    border-radius: 8px;
    padding: 0 20px;
    & > ul {
      list-style: none;
      padding: 20px 0;
      display: flex;
      overflow: hidden;
      & > li {
        flex-shrink: 0;
        width: 150px;
        background: #255CC5;
        border-radius: 5px;
        margin-right: 20px;
        padding: 8px;
        color: #FFF;

        & > span {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          line-height: 12px;
          & > img {
            width: 72px;
          }
        }
        & > h3 {
          font-size: 14px;
          color: #FFF;
          margin-top: 9px;
          line-height: 17px;
        }
        & > p {
          position: relative;
          margin-top: 30px;
          font-size: 12px;
          display: flex;
          align-items: center;
          line-height: 16px;

          & > img {
            position: absolute;
            width: 22px;
            top: 1px;
            right: 0;
          }

          &:before {
            content: '....';
            line-height: 8px;
            margin-top: -8px;
            margin-right: 10px;
          }
        }
        &:first-child {
          box-shadow: 0px 10px 20px -5px rgba(22, 20, 34, 0.5);
        }
      }
    }
  }

  .midden {
    display: flex;
    position: relative;
    margin-top: 16px;
    .pie {
      width: 171px;
      height: 151px;
      background: #3A3D40;
      border-radius: 8px;
    }
    .rate {
      position: relative;
      margin-left: 17px;
      width: 278px;
      height: 151px;
      background: #3A3D40;
      border-radius: 8px;
      overflow: hidden;
      & > img {
        position: absolute;
        left: -80px;
        top: -20px;
        width: 500px;
      }
      & > ul {
        position: absolute;
        bottom: 10px;
        list-style: none;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 4px;
        & > li {
          font-size: 12px;
          font-weight: 400;
          color: #A2A8AC;
        }
      }
    }
  }

  .bottom {
    position: relative;
    margin-top: 16px;
    background: #3A3D40;
    padding: 0 12px;
    border-radius: 8px;
    .bar {
      height: 150px;
    }
  }

  .exchange {
    position: absolute;
    padding: 60px 30px;
    background: linear-gradient(224deg, #70A8FF 0%, #1148B5 100%);
    box-shadow: 0px 40px 80px -20px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    bottom: -46px;
    left: -158px;
    overflow: hidden;

    .step1 {
      .input {
        display: flex;
        justify-content: space-between;
        width: 220px;
        padding: 12px 17px;
        background: #FFF;
        border-radius: 27px;
        & > span {
          display: flex;
          align-items: center;
          color: #2D4382;
          font-size: 16px;
          line-height: 24px;
          & > img {
            width: 23px;
            margin-right: 10px;
          }
        }
      }

      .line {
        position: relative;
        margin-left: 30px;
        height: 50px;
        border-left: #FFFFFF solid 1px;
        padding: 16px 14px;
        color: #FFFFFF;
        & > span {
          background: #FFFFFF;
          top: 20px;
          left: -5px;
          position: absolute;
          width: 9px;
          height: 9px;
          border-radius: 19px;
        }
        & > p {
          font-size: 12px;
          line-height: 18px;
        }
      }

      .btn {
        padding: 8px 78px;
        background:  rgba(255,255,255,0.2);
        box-shadow: 0px 20px 20px -5px rgba(0, 0, 0, 0.2);
        border-radius: 27px;
        margin-top: 40px;
        color: #FFFFFF;
        line-height: 24px;
        transition: all 0.2s;
      }
    }

    .step2 {
      background: linear-gradient(224deg, #70A8FF 0%, #1148B5 100%);
      opacity: 0;
      left: 0;
      top: 0;
      padding: 63px 40px;
      position: absolute;
      transition: all 0.5s;
      border-radius: 16px;
    }
    .showStep2 {
      opacity: 255;
    }

    .circle {
      position: relative;
      width: 200px;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .svgAni {
        position: absolute;
        display: flex;
        .circleAni {
          transform: rotate(-90deg);
          stroke-dasharray: 2388;
          stroke-dashoffset: 2388;
        }
        .tickAni {
          stroke-dasharray: 350;
          stroke-dashoffset: 350;
        }
        .circlePlay {
          animation: circleRun 1s cubic-bezier(1,.04,.32,.7) forwards;
        }
        .circleRevert {
          animation: circleRevert 0 forwards;
        }
        .tickPlay {
          animation: tickRun 0.8s ease-out forwards;
          animation-delay: 0.95s;
        }
        .tickRevert {
          animation: tickRevert 0 forwards;
        }

        @keyframes circleRun {
          from {
            stroke-dashoffset: 2388;
          }
          to {
            stroke-dashoffset: 1194;
          }
        }
        @keyframes circleRevert {
          from {
            stroke-dashoffset: 2388;
          }
          to {
            stroke-dashoffset: 2388;
          }
        }

        @keyframes tickRun {
          form {
            stroke-dashoffset: 350;
          }
          to {
            stroke-dashoffset: 0;
          }
        }
        @keyframes tickRevert {
          form {
            stroke-dashoffset: 0;
          }
          to {
            stroke-dashoffset: 350;
          }
        }

        & > p {
          position: absolute;
          left: 88px;
          bottom: 58px;
          text-align: center;
          font-size: 18px;
          line-height: 27px;
          color: #FFFFFF;
        }
      }


      .tips {
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 27px;
      }
    }
  }
</style>
